export default __webpack_public_path__ + "static/media/me.b1345e5f.png";